"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _axios = _interopRequireDefault(require("axios"));

var _dateFormatter = _interopRequireDefault(require("../../libs/translationsUtils/dateFormatter"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _TopicLabel = _interopRequireDefault(require("../topic-list-view/TopicLabel"));

var _htmlParser = _interopRequireDefault(require("../utils/htmlParser"));

var _TopicLike = _interopRequireDefault(require("../topic-list-view/TopicLike"));

var _TopicComments = _interopRequireDefault(require("../topic-list-view/TopicComments"));

var _TopicLastPost = _interopRequireDefault(require("../topic-list-view/TopicLastPost"));

var _urlGenerator = require("../utils/urlGenerator");

var _common = require("@insided/shared/utils/common");

var _TopicViewsCount = require("@insided/destination/uikit/TopicViewsCount");

var _ClampLines = _interopRequireDefault(require("@insided/shared/uikit/ClampLines"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ProductUpdateView = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ProductUpdateView, _Component);

  var _super = _createSuper(ProductUpdateView);

  function ProductUpdateView() {
    var _this;

    (0, _classCallCheck2.default)(this, ProductUpdateView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      likesCount: _this.props.likes,
      isCurrentUserLiked: _this.props.likedOrVotedByCurrentUser
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleLikeStatusToggle", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(e) {
        var event, _this$props, currentUser, id;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                e.stopPropagation();

                if (_this.props.currentUser) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                if (!(_this.props.currentUser.id === null)) {
                  _context.next = 8;
                  break;
                }

                event = new CustomEvent('GuestUserAction');
                window.dispatchEvent(event);
                return _context.abrupt("return");

              case 8:
                if (!_this.state.isCurrentUserLiked) {
                  _context.next = 15;
                  break;
                }

                _this$props = _this.props, currentUser = _this$props.currentUser, id = _this$props.id;
                _context.next = 12;
                return _axios.default.post("/community/api/productUpdates/".concat(id, "/unlike"), {
                  unlikedBy: currentUser.id
                });

              case 12:
                _this.setState(function (prevState) {
                  return {
                    isCurrentUserLiked: false,
                    likesCount: prevState.isCurrentUserLiked ? prevState.likesCount - 1 : prevState.likesCount
                  };
                });

                _context.next = 18;
                break;

              case 15:
                _context.next = 17;
                return _axios.default.post("/community/api/productUpdates/".concat(_this.props.id, "/like"), {
                  likedBy: _this.props.currentUser.id
                });

              case 17:
                _this.setState(function (prevState) {
                  return {
                    likesCount: prevState.likesCount + 1,
                    isCurrentUserLiked: true
                  };
                });

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    return _this;
  }

  (0, _createClass2.default)(ProductUpdateView, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          content = _this$props2.content,
          contentType = _this$props2.contentType,
          views = _this$props2.views,
          featuredImage = _this$props2.featuredImage,
          featuredImageAltText = _this$props2.featuredImageAltText,
          productAreas = _this$props2.productAreas,
          productAreasMapping = _this$props2.productAreasMapping,
          replyCount = _this$props2.replyCount,
          lastActivityAt = _this$props2.lastActivityAt,
          lastContributor = _this$props2.lastContributor,
          lastPostId = _this$props2.lastPostId,
          id = _this$props2.id,
          title = _this$props2.title,
          publicLabel = _this$props2.publicLabel,
          publishedAt = _this$props2.publishedAt,
          categoryName = _this$props2.categoryName,
          categoryUrl = _this$props2.categoryUrl,
          likes = _this$props2.likes,
          publicTopicUrl = _this$props2.topicUrl.destination;
      var isCurrentUserLiked = this.state.isCurrentUserLiked;

      var strippedContent = _htmlParser.default.stripHtml(content);

      var lastPostUrl = (0, _urlGenerator.getLastPostUrl)(publicTopicUrl, lastPostId);

      var relativeDate = _common.common.relativeDate(lastActivityAt);

      return (0, _preact.h)("article", {
        className: "product-update-view card-widget-wrapper"
      }, (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)(publicTopicUrl),
        className: "product-update-url",
        "aria-label": title
      }, Boolean(featuredImage) && (0, _preact.h)("img", {
        className: "product-update-view_feature-image",
        src: (0, _absoluteUrlRuntime.resolveUrl)(featuredImage),
        alt: featuredImageAltText || title
      }), (0, _preact.h)("div", {
        className: "product-update-view_info"
      }, (0, _preact.h)("div", {
        className: "product-update-view_info--metadata"
      }, (0, _preact.h)(_TopicLabel.default, {
        topic: {
          contentType: contentType,
          publicLabel: publicLabel
        }
      }), (0, _preact.h)("span", {
        className: "text--meta"
      }, (0, _preact.h)(_dateFormatter.default, {
        date: publishedAt
      }))), (0, _preact.h)("h4", {
        className: (0, _classnames.default)('card-widget-title', 'product-update-view_info-title', 'h3')
      }, title), (0, _preact.h)(_ClampLines.default, {
        id: "product-update-view",
        className: "card-widget-text product-update-view_info-content",
        innerElement: "p",
        lines: 4,
        text: strippedContent || ''
      }), _common.common.isModuleActive('categoriesV2IdeasAndPU') && !!categoryName && (0, _preact.h)("div", {
        className: "category-product-meta"
      }, (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)(categoryUrl),
        "data-track-type": "click",
        className: "topic-list-item-card_topic-location-link text--meta"
      }, (0, _preact.h)("span", {
        className: "text--meta"
      }, (0, _preact.h)(_phrase.default, {
        p: "product.update.posted.in"
      })), "\xA0", (0, _preact.h)("span", {
        className: "topic-view_header-item_category-link"
      }, categoryName))), Boolean(productAreas.length) && (0, _preact.h)("div", {
        className: "product-update-view_product-areas",
        "data-qa": "product-area-container"
      }, (0, _preact.h)("span", {
        className: "text--meta"
      }, (0, _preact.h)(_phrase.default, {
        p: "product.areas.related.products"
      }), ":"), productAreas.map(function (productAreaId) {
        return (0, _preact.h)("span", {
          key: productAreaId,
          className: "text--dot-underline product-area-item",
          "data-qa": "product-area-item"
        }, productAreasMapping[productAreaId]);
      })), (0, _preact.h)("div", {
        className: "topic-view_footer"
      }, (0, _preact.h)("ul", {
        className: "topic-view_footer-items"
      }, (0, _preact.h)(_TopicLike.default, {
        className: isCurrentUserLiked ? 'active' : '',
        onClick: this.handleLikeStatusToggle,
        displayLikeCount: true,
        likeCount: likes
      }), (0, _preact.h)("li", {
        className: (0, _classnames.default)('thread-meta-item', 'thread-meta-item--hover-highlight', 'is-hidden-S')
      }, (0, _preact.h)(_TopicViewsCount.TopicViewsCountAction, {
        href: (0, _absoluteUrlRuntime.resolveUrl)(publicTopicUrl)
      }, (0, _preact.h)(_TopicViewsCount.TopicViewsCount, {
        views: views
      }))), (0, _preact.h)("li", {
        className: "thread-meta-item"
      }, (0, _preact.h)(_TopicComments.default, {
        numberOfReplies: replyCount,
        id: id,
        lastPostUrl: lastPostUrl
      })), (0, _preact.h)("li", {
        className: "thread-meta-item"
      }, (0, _preact.h)(_TopicLastPost.default, {
        lastPostAuthor: _objectSpread(_objectSpread({}, lastContributor), {}, {
          name: lastContributor.username
        }),
        lastPostUrl: lastPostUrl,
        lastPostRelativeCreationDate: relativeDate
      })))))));
    }
  }]);
  return ProductUpdateView;
}(_preact.Component);

var _default = ProductUpdateView;
exports.default = _default;